module.exports = __webpack_public_path__ + "img/welding-5.fb199d05.jpg";